import { useTranslation } from 'react-i18next'
import { Globe } from 'lucide-react'
import { SUPPORTED_LANGUAGES, type SupportedLanguage } from '@/i18n'
import { useTenantStore } from '@/store/tenantStore'

interface LanguageSwitcherProps {
  variant?: 'light' | 'dark'
  alwaysShow?: boolean
}

export function LanguageSwitcher({
  variant = 'light',
  alwaysShow = false,
}: LanguageSwitcherProps = {}) {
  const { i18n, t } = useTranslation('common')
  const tenantInfo = useTenantStore((state) => state.tenantInfo)

  // alwaysShow=true 이거나 조직의 languageMode === 'both' 일 때만 노출
  if (!alwaysShow && tenantInfo?.languageMode !== 'both') {
    return null
  }

  const currentLang = (SUPPORTED_LANGUAGES.includes(i18n.language as SupportedLanguage)
    ? i18n.language
    : 'ko') as SupportedLanguage

  const nextLang: SupportedLanguage = currentLang === 'ko' ? 'en' : 'ko'

  const handleToggle = () => {
    i18n.changeLanguage(nextLang)
  }

  const base =
    'flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-sm font-medium transition-colors'
  const skin =
    variant === 'dark'
      ? 'bg-gray-800 hover:bg-gray-700 text-gray-100'
      : 'bg-gray-100 hover:bg-gray-200 text-gray-700'

  return (
    <button
      onClick={handleToggle}
      className={`${base} ${skin}`}
      title={t(`language.${nextLang}`)}
    >
      <Globe className="w-4 h-4" />
      <span>{currentLang.toUpperCase()}</span>
    </button>
  )
}
